import { shouldApplyEAEULogic } from '../../../../utils/eaeuHelper';
import { isUnsuitableCargoName, CARGO_NAME_MESSAGE, normalizeCargoCountryCode } from '../../../../utils/cargoNameValidation';
const ALLOWED_ARTICLE_RE = /^[A-Za-zА-Яа-я0-9!@"#№$;%^:&?*()_\-+=<>,.{}\[\]\\\/ ]+$/u;

function checkForZeros(object) {
    let errors = {};
  
    for (let key in object) {
        if (!object[key]) {
            if (key == "weight") {
                errors.weight = 'place_weight_invalid_error';
            }
  
            else {
              errors.size = 'place_size_invalid_error';
            }
        }
    }
  
    return errors
  }
  
  function checkForOverflow(object) {
    let errors = {};

    if (!object.width || object.width < 0.01 || object.width > 1000) {
        errors.width = 'place_width_invalid_error';
    }

    if (!object.length || object.length < 0.01 || object.length > 1000) {
        errors.length = 'place_width_invalid_error';
    }

    if (!object.height || object.height < 0.01 || object.height > 1000) {
        errors.height = 'place_width_invalid_error';
    }
  
    return errors
  }

export default function validate(data) {
    let errors = {};

    if (!data.contract_number) {
        errors.contract_number = 'contract_number_error';
    }

    if (!data.cityFrom) {
        errors.cityFrom = 'cityFrom_error';
    }

    if (!data.cityTo) {
        errors.cityTo = 'cityTo_error';
    }

    if (!data.places) {
        errors.places = 'places_error';
    }

    if (!data.user_type) {
        errors.user_type = 'user_type_error';
    }

    let total_sum = data.places?.reduce((total, place) => {
        return total + place.goods?.reduce((total, good) => {
            return total + good.insurance * good.count;
        }, 0);
    }, 0);

    if (total_sum > 399999) {
      errors.sum_overflow = 'sum_overflow_error';
    }

    data.places?.forEach((place, index) => {
        let place_errors = checkForZeros(place);
        let place_overflow = checkForOverflow(place);
    
        place_errors = {...place_errors, ...place_overflow}
    
        if (place_errors && Object.keys(place_errors).length) {
          errors[`places.${index}`] = place_errors;
        }
    
        place.goods?.forEach((good, i) => {
          let good_errors = {};

          if (good.article?.length > 50) {
            good_errors.article = 'good_article_max_len';
          } else if (good.article && !ALLOWED_ARTICLE_RE.test(good.article)) {
            good_errors.article = 'good_article_bad_input';
          }
    
          if (shouldApplyEAEULogic(normalizeCargoCountryCode(data.cityFromCountryCode), normalizeCargoCountryCode(data.cityToCountryCode)) && isUnsuitableCargoName(good.name)) {
            good_errors.name = CARGO_NAME_MESSAGE;
          } else if (!good.name) {
            good_errors.name = 'good_name_error';
          }
    
          if (!good.insurance || parseFloat(good.insurance) <= 0) {
            good_errors.insurance = 'good_insurance_error';
          }
    
          if (!good.count || parseInt(good.count) <= 0) {
            good_errors.count  = 'good_quantity_error';
          }
    
          if (!good.weight || parseFloat(good.weight) <= 0) {
            good_errors.weight  = 'good_weight_error';
          }
    
          if (good_errors && Object.keys(good_errors).length) {
            if (!errors[`places.${index}`]) {
              errors[`places.${index}`] = {};
            }
            
            errors[`places.${index}`][`goods.${i}`] = good_errors;
          }
        })
    
      })

    return errors
}
